module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_fooldal1.bd087602.jpg";